const module = { name: 'mobile/search', exports: {} }; const exports = module.exports;



import { fd_url_manager as links } from 'require-core';



import { Fandango_clearableInput as clearableInput } from 'require-core';



import { default as searchAutocompleteFormEvents } from 'swug-fdRequire-call:mobile/searchAutocomplete/form/events';



import { Fandango_util as util } from 'require-global';



const MAX_RESULTS = 10000


const Selectors = {
    CANCEL_BTN: '#search-cancel',
    FORM: '#search-form-shell-form',
    OUTPUT: '#autocomplete-search-results',
}


const Styles = {
    FD_CLEARABLE_INPUT: 'fd-clearable-input__input',
    FLOATING_LABEL: 'fd-floating-label',
    FLOATING_LABEL_ACTIVE: 'fd-floating-label--active',
    FLOATING_LABEL_LABEL: 'fd-floating-label__label',
}


const IDs = {
    INPUT: 'autocomplete-search-input'
}


const LABELS = {
    INPUT_LABEL: 'Search Films + Cinemas',
}


const RegExes = {
    QUERY_PARAM: /[?&]q=([^&]+)/i
}
function getKeywordFromURL() {
    const queryString = (window.location.search || '').trim();
    if (!queryString.length) {
        return '';
    }
    const matches = queryString.match(RegExes.QUERY_PARAM);
    if (!matches || matches.length < 2) {
        return '';
    }
    const keyword = decodeURIComponent(matches[1]);
    return searchAutocompleteFormEvents.cleanInput(keyword);
}
function makeInput(formId, inputId, keyword) {
    const input = document.createElement('input');
    input.classList.add(Styles.FD_CLEARABLE_INPUT);
    input.id = inputId;
    input.name = 'q';
    input.type = 'text';
    input.value = keyword || '';
    input.tabIndex = '1';
    const form = document.querySelector(formId);
    if (form) {
        const clearableInputMarkup = clearableInput.make(input, {
            isSearch: true,
            isModal: true,
            label: LABELS.INPUT_LABEL,
        });
        clearableInputMarkup.classList.add(Styles.FLOATING_LABEL);
        const label = document.createElement('label');
        label.classList.add(Styles.FLOATING_LABEL_LABEL);
        label.htmlFor = input.id;
        label.textContent = LABELS.INPUT_LABEL;
        clearableInputMarkup.appendChild(label);
        const updateFloatingLabelState = () => {
            const hasValue = ((input.value || '').trim().length > 0);
            const isFocused = document.activeElement === input;
            clearableInputMarkup.classList.toggle(Styles.FLOATING_LABEL_ACTIVE, hasValue || isFocused);
        };
        input.addEventListener('focus', updateFloatingLabelState);
        input.addEventListener('blur', updateFloatingLabelState);
        input.addEventListener('input', updateFloatingLabelState);
        updateFloatingLabelState();
        form.appendChild(clearableInputMarkup);
    }
    return input;
}
function onCancelClick(e) {
    e.preventDefault();
    const destination = document.referrer.indexOf(document.location.pathname) > -1
        ? links.baseCanonicalUrl()
        : document.referrer;
    util.navigate(destination);
}
function init() {
    const keyword = getKeywordFromURL();
    const input = makeInput(Selectors.FORM, IDs.INPUT, keyword);
    const output = document.querySelector(Selectors.OUTPUT);
    const opts = {
        maxResults: MAX_RESULTS,
        keyword,
        isManualSearch: true
    };
    searchAutocompleteFormEvents.init(input, output, opts);
    const cancelBtn = document.querySelector(Selectors.CANCEL_BTN);
    if (cancelBtn) {
        cancelBtn.addEventListener('click', onCancelClick);
    }
}
module.exports = {
    init
};
export default module.exports;